import { useTranslation } from "react-i18next";
import CustomSharedConfirmationModal from "sipli-fleet-core/components/CustomSharedConfirmationModal/CustomSharedConfirmationModal";

interface MappingDeleteProps {
  open: boolean;
  isLoading: boolean;
  title?: string;
  zIndex?: number;
  onCancel: () => void;
  onConfirm: () => void;
}

const MappingDelete = ({
  open,
  isLoading,
  title,
  zIndex,
  onCancel,
  onConfirm,
}: MappingDeleteProps) => {
  const { t } = useTranslation();

  return (
    <CustomSharedConfirmationModal
      open={open}
      title={title ?? t("delete_mapping", { defaultValue: "Delete mapping" })}
      description={t("delete_mapping_confirmation", {
        defaultValue: "Are you sure you want to delete?",
      })}
      confirmText={t("delete")}
      cancelText={t("cancel")}
      isLoading={isLoading}
      zIndex={zIndex}
      onCancel={onCancel}
      onConfirm={onConfirm}
      centered
    />
  );
};

export default MappingDelete;
